<app-material>
    <div class="header" header>
        <h2>{{ ('admin.audits.table.title' | translate) + (selectedEntity ? (' - ' + selectedEntity.name) : '') }}</h2>
        <app-audits-form [entities]="entities"
                         (entityChange)="onEntityChange($event)"
                         (formChange)="onFormChange($event)"
                         (download)="downloadAudits()">
        </app-audits-form>
    </div>
    <div class="content" body>
        <app-audits-table [audits]="audits"
                          [tableConfig]="tableConfig"
                          [isLoading]="isLoadingAudits"
                          [hasTitle]="false"
                          [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                          [operations]="operations"
                          [entity]="selectedEntity"
                          (sortChange)="onSortChange($event)"
                          (filterChange)="onFilterChange($event)"
                          (pageChange)="onPageChange($event)">
        </app-audits-table>
    </div>
</app-material>




